import React from 'react';
import './App.css';
import PasswordGenerator from './components/PasswordGenerator';
import PasswordShareViewer from './components/PasswordShareViewer';

function App() {
  const shareMatch = window.location.pathname.match(/^\/share\/([^/]+)/);

  if (shareMatch) {
    return <PasswordShareViewer shareId={shareMatch[1]} />;
  }

  return (
    <div className="App">
      <PasswordGenerator />
    </div>
  );
}

export default App;
